import React from 'react'
import Select, { components } from 'react-select'
import PropTypes from 'prop-types'
import styles from './checkbox.module.css'

const dummyOptions = [
  {
    label: 'Placeholder',
    value: 'Placeholder'
  },
  {
    label: 'Placeholder A',
    value: 'Placeholder1'
  },
  {
    label: 'Placeholder B',
    value: 'Placeholder2'
  },
  {
    label: 'Placeholder C',
    value: 'Placeholder3'
  },
]

// Remove 'X' button
// const MultiValueRemove = () => <span></span>

const Option = (props) => {
  const isAll = props.value === 'all'

  return (
    <div>
      <components.Option {...props}>
        <div className={`flex ${isAll ? 'bg-gray-100 p-2 rounded' : ''} ${styles.checkbox}`}>
          {
            !isAll &&
            <div>
              <input type="checkbox" /* id={`${props.value.split(' ').join('')}_id`} */ className="hidden" onChange={e => null} checked={props.isSelected}/>
              <div className={`mr-2 border flex justify-center items-center ${styles.outer}`}>
                <div className={styles.inner}></div>
              </div>
            </div>
          }
          <label className="cursor-pointer text-sm text-gray-444">{props.label}</label>
        </div>

        {/* <input
          type="checkbox"
          checked={props.isSelected}
          onChange={e => null}
        />{" "}
        <label>{props.value} </label> */}
      </components.Option>
    </div>
  )
}

const SelectCheckbox = ({options, ...props}) => {
  const styles = {
    option: base => ({
      ...base,
      background: `#fff`,
      color: '#444',
      height: '100%',
    }),
    multiValueLabel: base => ({
      ...base,
      backgroundColor: '#f5f5f5',
      color: '#444',
    }),
  }

  if(props.allowSelectAll){
    const isAllSelected = props.value?.length === options?.length
    if (isAllSelected) {
      return (
        <Select
          {...props}
          closeMenuOnSelect={false}
          isMulti
          styles={styles}
          hideSelectedOptions={false}
          components={{ Option/* , MultiValueRemove */ }}
          options={options}
          // onChange={selected => props.onChange(selected.slice(1))}
        />
      );
    }

    return (
      <Select
        {...props}
        closeMenuOnSelect={false}
        isMulti
        styles={styles}
        hideSelectedOptions={false}
        components={{ Option/* , MultiValueRemove */ }}
        options={[props.allOption, ...options]}
        onChange={selected => {
          if (
            selected &&
            selected !== null &&
            selected.length > 0 &&
            selected[selected.length - 1].value === props.allOption.value
          ) {
            return props.onChange(options);
          }
          return props.onChange(selected);
        }}
      />
    );
  }

  return (
    <Select
      closeMenuOnSelect={false}
      isMulti
      styles={styles}
      hideSelectedOptions={false}
      components={{ Option/* , MultiValueRemove */ }}
      options={options}
      {...props}
    />
  )
}

SelectCheckbox.propTypes = {
  options: PropTypes.array
}

SelectCheckbox.defaultProps = {
  options: dummyOptions
}

export { SelectCheckbox }
